import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "../api";

const FIELDS = [
  ["cnpj", "CNPJ do prestador (sua empresa)"], ["inscricaoMunicipal", "Inscrição municipal"],
  ["codigoMunicipio", "Código IBGE do seu município (7 dígitos)"], ["itemListaServico", "Item da lista de serviço (LC 116), ex.: 04.03"],
  ["codigoTributarioMunicipio", "Código tributário do município (se a prefeitura exigir)"], ["codigoCnae", "CNAE (opcional)"],
  ["aliquota", "Alíquota do ISS (%)"],
];

export default function FiscalSettings({ fiscal, setFiscal, canEdit }) {
  const [f, setF] = useState(null);
  const [token, setToken] = useState("");
  const [saving, setSaving] = useState(false);
  useEffect(() => { if (fiscal) { setF({ ...fiscal }); } }, [fiscal]);
  if (!f) return <p className="hint">Carregando…</p>;
  const set = (k) => (e) => setF({ ...f, [k]: e.target.type === "checkbox" ? e.target.checked : e.target.value });

  const save = async (extra = {}) => {
    setSaving(true);
    try {
      const { data } = await api.put("/fiscal/settings", { ...f, aliquota: f.aliquota === "" || f.aliquota == null ? null : Number(f.aliquota), token, ...extra });
      setFiscal(data); setToken(""); toast.success("Configuração fiscal salva.");
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); } finally { setSaving(false); }
  };

  return (
    <article className="card" data-testid="fiscal-settings">
      <h2>Emissão automática de nota fiscal (NFS-e)</h2>
      <div className={`fiscal-status ${f.hasToken ? "on" : "off"}`} data-testid="fiscal-status">
        {f.hasToken ? `Emissão ativada • ambiente: ${f.environment === "producao" ? "Produção (nota com valor fiscal)" : "Homologação (teste, sem valor fiscal)"}` : "Emissão ainda não ativada — o botão \"Emitir nota\" fica desligado até você informar o token do emissor."}
      </div>
      <ol className="hint" style={{ margin: "10px 0 14px", paddingLeft: 18, lineHeight: 1.7 }}>
        <li>Crie sua conta na Focus NFe (focusnfe.com.br), cadastre sua empresa e envie o certificado digital A1 no painel deles.</li>
        <li>Copie o token de acesso (homologação para testar, produção para valer) e cole abaixo.</li>
        <li>Preencha os dados fiscais com a ajuda do seu contador e salve. Depois, cada serviço terá o botão "Emitir nota".</li>
      </ol>
      <fieldset disabled={!canEdit} style={{ border: 0, padding: 0, margin: 0 }}>
        <div className="module-grid two-col">
          <label className="full-label">Ambiente<select value={f.environment} onChange={set("environment")} data-testid="fiscal-env"><option value="homologacao">Homologação (teste)</option><option value="producao">Produção (valor fiscal)</option></select></label>
          <label className="full-label">Token do emissor (Focus NFe)<input type="password" value={token} onChange={(e) => setToken(e.target.value)} placeholder={f.hasToken ? "•••••• salvo (preencha só para trocar)" : "Cole o token aqui"} data-testid="fiscal-token" autoComplete="off" /></label>
          {FIELDS.map(([k, l]) => <label className="full-label" key={k}>{l}<input value={f[k] ?? ""} onChange={set(k)} data-testid={`fiscal-${k}`} /></label>)}
        </div>
        <label className="check-line"><input type="checkbox" checked={!!f.optanteSimples} onChange={set("optanteSimples")} data-testid="fiscal-simples" /> Optante pelo Simples Nacional</label>
        <label className="check-line"><input type="checkbox" checked={!!f.issRetido} onChange={set("issRetido")} data-testid="fiscal-iss-retido" /> ISS retido pelo tomador</label>
        {canEdit && (
          <div style={{ marginTop: 14, display: "flex", gap: 8, flexWrap: "wrap" }}>
            <button className="primary" onClick={() => save()} disabled={saving} data-testid="fiscal-save">{saving ? "Salvando…" : "Salvar configuração fiscal"}</button>
            {f.hasToken && <button className="secondary" onClick={() => window.confirm("Desativar a emissão (remover o token)?") && save({ removeToken: true })} data-testid="fiscal-remove-token">Desativar emissão</button>}
          </div>
        )}
      </fieldset>
      {!canEdit && <p className="hint" style={{ marginTop: 10 }}>Somente o administrador pode alterar a configuração fiscal.</p>}
    </article>
  );
}
